export default [
    {
        text: 'Folio',
        value: 'number',
    },
    {
        text: 'Documento',
        value: 'document',
    },
    {
        text: 'fecha emisión',
        value: 'emission_date',
        format: 'date'
    },
    {
        text: 'monto',
        value: 'amount',
        format: 'currency'
    },
    {
        text: 'pagado',
        value: 'paid_amount',
        format: 'currency'
    },
    {
        text: 'saldo',
        value: 'to_pay',
        format: 'currency'
    },
    {
        text: 'fecha vencimiento',
        value: 'pay_date',
        format: 'date'
    },
    {
        text: 'fecha pago',
        value: 'real_pay_date',
        format: 'date'
    },
    {
        text: 'Estado',
        value: 'status',
    }
]
